import React from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { fetchServer } from "../Base/modelManager";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import {  Container } from "react-bootstrap";
import { serverError } from "../../redux/actions/serverManagerAction";
import moment from "moment";


class ModesPaiements extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            data: {},
            loadding: false,
        }
    }

    componentDidMount() {
        if (this.props.currentClient !== undefined && this.props.currentClient !== null)
            this.getCurrentModesPaiements()
    }

    componentDidUpdate(prevProp) {
        if (this.props.currentClient !== undefined && this.props.currentClient !== null)
            if (prevProp.currentClient !== this.props.currentClient) {
                this.getCurrentModesPaiements()

            }
    }
    getCurrentModesPaiements = () => {
        const { loading } = this.state

        if (!loading) {

            this.setState({
                loading: true,
                data: {}
            })
            const request = {
                endPoint: this.props.apiUrl + '/Services/Clients/modePaiement',
                method: 'GET',
                token: this.props.JWTToken
            }
            fetchServer(request,
                (json) => {

                    this.setState({ data: json, loading: false })
                },
                (json) => {
                    this.setState({ data: {}, loading: false })
                    this.props.dispatch(serverError(json.error))
                }


            )
        }
    }


    onPropertyChange = (event) => {
        const { data } = this.state
        data[event.target.name] = event.target.value
        this.setState({ data: { ...data } })
    }


    render() {
        const { data } = this.state

        return (
            <section>
                <Container id="AdrCorrespondance" className="justify-content-md-center">
                    <Row className="header">
                        - MES COORDONNÉES BANCAIRES -
                    </Row>
                    <Row>
                        <Col sm="3">
                            DOMICILIATION
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='domicil' value={data.domicil} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            IBAN
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='iban' value={data.iban} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            BIC
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='bic' value={data.codebic} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            N° RUM
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='mandatSepa' value={data.mandatsepa} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            DATE DU MANDAT
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='datemandat' value={moment(data.datemandat).format('L')} />
                        </Col>
                    </Row>
                    {/*
                    <Row className="justify-content-md-center" >
                        <Col></Col>
                        <Col>
                            <Button style={{ width: '180px' }} type="submit">TELECHARGER MANDAT SEPA</Button>
                        </Col>
                        <Col></Col>
                        <Col>
                            <Button style={{ width: '180px' }} type="submit">TELECHARGER RIB</Button>
                        </Col>
                        <Col></Col>


                    </Row>
                     */}
                </Container>


                <Container id="AdrFacturation" className="justify-content-md-center">
                    <Row className="header">
                        - MES CONDITIONS DE PAIEMENT -
                    </Row>
                    <Row>
                        <Col sm="3">
                            Prélèvement automatique
                        </Col>
                        <Col sm="9">
                            <Form.Check name='preleauto' checked={data.prelevementauto} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            Virement
                        </Col>
                        <Col sm="9">
                            <Form.Check name='virement' checked={!data.prelevementauto}/>
                        </Col>
                    </Row>
                    {/*
                    <Row>
                        <Col sm="3">
                            Carte Bancaire
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='adrfact3' value={data.adrfact3} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            Chèque
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='cpfact' value={data.cpfact}  />
                        </Col>
                    </Row>
                    */}
                    <Row>
                        <Col sm="3">
                            PÉRIODICITÉ FACTURE
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='villefact' value={data.periodicitefacture===1?'HEBDOMADAIRE':data.periodicitefacture===2?'QUINZAINE':'MENSUEL'} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            ÉCHÉANCE PRÉLÈVEMENT
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='villefact' value={'j+' + data.echeancePrelevement }  />
                        </Col>
                    </Row>
                </Container>

                {/*this.props.currentClient ?// && this.props.currentClient.gestion === true ?
                    <Row className="justify-content-md-center">
                        <Button id='saveAdresse' onClick={() => {
                            console.log(data)
                            const request = {
                                endPoint: this.props.apiUrl + '/Services/Clients/ModePaiement',
                                method: 'POST',
                                params: {
                                    clientid: this.props.currentClient.uid,
                                    values: data,
                                },
                                token: this.props.JWTToken
                            }
                            fetchServer(request,
                                (json) => {

                                    this.setState({ loading: false })
                                },
                                (json) => {
                                    this.setState({ data: {}, loading: false })
                                    this.props.dispatch(serverError(json.error))
                                }


                            )
                        }}>Enregistrer</Button>
                    </Row>
                    : null
                    */}

            </section>
        )
    }
}


const mapStateToProps = (state) => {

    return ({
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

ModesPaiements.propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string,
    apiUrl: PropTypes.string
};

export default connect(mapStateToProps)(ModesPaiements);
